enum ContactFormActionType {
  SendEmail,
  VerifyReCaptcha,
}

export default ContactFormActionType
